export const QUERY_KEYS = {
  // User
  GET_USER_COMPANIES_ALL_USERS: 'GET_USER_COMPANIES_ALL_USERS',
  GET_USER_COMPANIES_CURRENT_USER_ADMIN_STATE: 'GET_USER_COMPANIES_CURRENT_USER_ADMIN_STATE',
  GET_USER_COMPANIES_ALL_USER_ROLES: 'GET_USER_COMPANIES_ALL_USER_ROLES',
  // Comments in report page
  GET_ALL_COMMENTS: 'GET_ALL_COMMENTS',
  GET_ALL_COMMENTS_BY_FUND_ID: 'GET_ALL_COMMENTS_BY_FUND_ID',
  ADD_COMMENT_BY_FUND_ID: 'ADD_COMMENT_BY_FUND_ID',
  DELETE_COMMENT_BY_ID: 'DELETE_COMMENT_BY_ID',
  // Agent chat
  GET_AGENT_CHATS: 'GET_AGENT_CHATS',
  GET_AGENT_CHAT_MESSAGES: 'GET_AGENT_CHAT_MESSAGES',
  GET_AGENT_INFO: 'GET_AGENT_INFO',
  GET_SESSION_FILES: 'GET_SESSION_FILES'
};
